import dlv from 'dlv';
import { isNumber } from 'lodash';

import { IOffer } from '@rbi-ctg/menu';
import { IExternalOffers } from 'generated/sanity-graphql';
import { CustomEventNames, EventTypes, IMParticleCtx } from 'state/mParticle';
import { getFirstStringInLocaleBlockContent } from 'utils/sanity';

export const logOfferClick = (
  offer: IOffer,
  offerIndex: number | undefined | null,
  offersDisplayed: number | undefined | null,
  ctx: IMParticleCtx
) => {
  ctx.trackEvent({
    name: CustomEventNames.OFFER_CLICK,
    type: EventTypes.UserContent,
    attributes: {
      'Offer Name': offer.name ? getFirstStringInLocaleBlockContent(offer.name) : '',
      'Short Code': offer.shortCode,
      'Sanity ID': offer._id,
      'Offer Position': isNumber(offerIndex) ? offerIndex + 1 : undefined,
      'Offer Display Count': offersDisplayed,
      'UI Pattern': offer.uiPattern,
    },
  });

  ctx.trackEvent({
    name: CustomEventNames.OFFER_SELECTED,
    type: EventTypes.Other,
    attributes: {
      engineId: '',
      sanityId: offer._id,
      name: offer.name ? getFirstStringInLocaleBlockContent(offer.name) : '',
    },
  });
};

export const logExternalOfferClick = (
  offer: IExternalOffers,
  offerIndex: number | undefined | null,
  offersDisplayed: number | undefined | null,
  ctx: IMParticleCtx
) => {
  ctx.trackEvent({
    name: CustomEventNames.OFFER_CLICK,
    type: EventTypes.UserContent,
    attributes: {
      'Offer Name': dlv(offer, 'title.locale', ''),
      'Sanity ID': offer._id,
      'Offer Position': isNumber(offerIndex) ? offerIndex + 1 : undefined,
      'Offer Display Count': offersDisplayed,
    },
  });

  ctx.trackEvent({
    name: CustomEventNames.OFFER_SELECTED,
    type: EventTypes.Other,
    attributes: {
      engineId: '',
      sanityId: offer._id,
      name: dlv(offer, 'title.locale', ''),
    },
  });
};
